__turbopack_context__.v({
  "aff__link": "ztMXZa_aff__link",
  "aff_four-column": "ztMXZa_aff_four-column",
  "authorSearchAff": "ztMXZa_authorSearchAff",
  "dealspage__book_retailers": "ztMXZa_dealspage__book_retailers",
  "dealspage__buy_button": "ztMXZa_dealspage__buy_button",
  "dealspage__buy_button_ORM": "ztMXZa_dealspage__buy_button_ORM",
  "dealspage__buy_button_disabled": "ztMXZa_dealspage__buy_button_disabled",
  "dealspage__dropdown": "ztMXZa_dealspage__dropdown",
  "searchAff": "ztMXZa_searchAff",
  "select": "ztMXZa_select",
});
